export const OTHER = "Other";
export const OTHER_AMOUNT = -1;
export const ENTER_TIP_AMOUNT = "Enter Tip Amount";

export const ASCII_CODES = {
    ENTER: 13,
    BACK_SPACE: 8,
    ZERO: 48,
    NINE: 57,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
};
